<template>
    <img src="https://static.tildacdn.info/tild6531-6531-4566-b862-343963613761/logoRND.svg" alt="FORWARD R&D" height="37" />
</template>